import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { getWeeklyRecommendationDataBaseSelector } from "../../recommendationWeeklyQuerySelector";
import { OrganisationWeeklyOffHoursRecommendation } from "../../../../../../services/cloudchipr.api";

export const recommendationDbWeeklyActiveDataSelector = createDraftSafeSelector(
  [getWeeklyRecommendationDataBaseSelector],
  (response): OrganisationWeeklyOffHoursRecommendation[] =>
    response?.data ?? [],
);
